import {
    getApiErrorMessage,
    getFormMode,
    getRecordFromResponse,
    getResponseData,
    validateSchemaFields
} from 'lib/formUtils';
import {
    listStyles,
    handleListDeleteIconMouseEnter,
    handleListIconMouseEnter,
    handleListIconMouseLeave
} from 'lib/listUtils';
import {
    Box,
    Button,
    CardContent,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography
} from '@material-ui/core';
import {
    Close,
    DeleteForeverOutlined,
    EditTwoTone,
    Search
} from '@material-ui/icons';
import theme from 'theme';
import api from 'services/api';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { safeSetState } from 'lib/reactUtils';
import { ComboPadrao, FormActions } from 'views/Components';
import { formatTime, getDateInputValue } from 'lib/functions';
import { ATEND_SAC_ABERTO, ATEND_SAC_ENCERRADO } from 'consts';
import { AlertInformation, DeleteConfirmationModal } from 'components';

class AtendimentoSacForm extends Component {
    _isMounted = false;
    safeSetState = safeSetState;

    handleIconMouseEnter = handleListIconMouseEnter;
    handleIconMouseLeave = handleListIconMouseLeave;
    handleDeleteIconMouseEnter = handleListDeleteIconMouseEnter;

    state = {
        atendimento: {
            idatendimento: '',
            idclassifatendimento: '',
            codos: '',
            nroreservacli: '',
            codhotel: '',
            datain: '',
            datafim: '',
            telefone1: '',
            telefone2: '',
            nomespax: '',
            situacao: ATEND_SAC_ABERTO
        },
        classificacoes: [],
        hoteis: [],
        subclassificacoes: [],
        subclassificacoesSelecionadas: new Set(),
        detalhes: [],
        osSelecionada: null,
        osBuscaAberta: false,
        osBuscaTermo: '',
        osBuscaResultados: [],
        osBuscando: false,
        isLoading: true,
        isNewRecord: false,
        isView: false,
        openAlert: false,
        messageAlert: '',
        errors: {},
        schema: {
            idclassifatendimento: {
                presence: {
                    allowEmpty: false,
                    message: 'Classificação obrigatória'
                }
            }
        },
        openDetalhe: false,
        detalheEditando: null,
        descritivoDetalhe: '',
        openExcluirDetalhe: false,
        detalheParaExcluir: null,
        criadoNaSessao: false
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;

        const {
            id,
            isNewRecord,
            isView
        } = getFormMode(this.props.match, this.props.location);

        try {
            if (isNewRecord) {
                const [classificacoes, hoteis] = await Promise.all([
                    this.loadClassificacoes(),
                    this.loadHoteis()
                ]);

                this.safeSetState({
                    isNewRecord: true,
                    isView: false,
                    isLoading: false,
                    atendimento: this.getAtendimentoDefault(),
                    classificacoes,
                    hoteis
                });

                return;
            }

            if (!isNaN(Number(id))) {
                await this.loadAtendimento(id, isView);
            }
        } catch (error) {
            console.error(
                'Erro ao carregar o atendimento SAC:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(error, 'Erro ao carregar o atendimento SAC!')
            );

            this.safeSetState({ isLoading: false });
        }
    };

    /* Limpa a flag de montagem ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;
    };

    /* Retorna o atendimento padrão */
    getAtendimentoDefault = () => ({
        idatendimento: '',
        idclassifatendimento: '',
        codos: '',
        nroreservacli: '',
        codhotel: '',
        datain: '',
        datafim: '',
        telefone1: '',
        telefone2: '',
        nomespax: '',
        situacao: ATEND_SAC_ABERTO
    });

    /* Carrega as classificações de atendimentos */
    loadClassificacoes = async (idclassifatendimento) => {
        const url = idclassifatendimento
            ? `/classifatendimentosac/listforchange/${idclassifatendimento}`
            : '/classifatendimentosac/active/true';

        const response = await api.get(url);

        return getResponseData(response);
    };

    /* Formata a descrição das OSs */
    formatarOs = (os) => ({
        ...os,
        descos: `${os.nroos} [${os.titular}]`
    });

    /* Carrega só a OS já vinculada ao atendimento */
    loadOsSelecionada = async (codos) => {
        if (!codos) return null;

        const response = await api.get(`/os-resumo/listforchange/${codos}`);
        const oss = getResponseData(response);

        return oss[0] ? this.formatarOs(oss[0]) : null;
    };

    /* Abre a busca de OS */
    onClickBuscarOs = () => {
        this.setState({
            osBuscaAberta: true,
            osBuscaTermo: '',
            osBuscaResultados: []
        });
    };

    /* Fecha a busca sem alterar a OS já selecionada */
    onClickFecharBuscaOs = () => {
        this.setState({ osBuscaAberta: false });
    };

    /* Altera o termo de busca - não dispara pesquisa sozinho */
    onChangeOsBuscaTermo = (event) => {
        this.setState({
            osBuscaTermo: String(event.target.value).toUpperCase()
        });
    };

    /* Dispara a busca de OS no servidor - só ao clicar na lupa ou apertar Enter */
    onBuscarOs = async () => {
        const { osBuscaTermo } = this.state;
        const termoBusca = String(osBuscaTermo || '').trim().toUpperCase();

        if (!termoBusca) {
            this.setState({ osBuscaResultados: [] });

            return;
        }

        this.setState({ osBuscando: true });

        try {
            const response = await api.get(
                `/os-resumo?limit=50&BUSCA=_like_${encodeURIComponent(osBuscaTermo.trim())}`
            );

            const oss = getResponseData(response);

            this.safeSetState({
                osBuscaResultados: oss.map(this.formatarOs),
                osBuscando: false
            });
        } catch (error) {
            console.error('Erro ao buscar OS:', error);

            this.safeSetState({
                osBuscaResultados: [],
                osBuscando: false
            });
        }
    };

    /* Dispara a busca ao pressionar Enter no campo */
    onKeyDownBuscaOs = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.onBuscarOs();
        }
    };

    /* Seleciona uma OS encontrada na busca */
    onSelectOs = (os) => {
        this.setState(prevState => ({
            atendimento: {
                ...prevState.atendimento,
                codos: os.codos
            },
            osSelecionada: os,
            osBuscaAberta: false,
            osBuscaTermo: '',
            osBuscaResultados: []
        }));
    };

    /* Remove a OS selecionada */
    onClickLimparOs = () => {
        this.setState(prevState => ({
            atendimento: {
                ...prevState.atendimento,
                codos: ''
            },
            osSelecionada: null
        }));
    };

    /* Carrega os hotéis */
    loadHoteis = async (codhotel) => {
        const url = codhotel ? `/hotel/listforchange/${codhotel}` : '/hotel/active/true';

        const response = await api.get(url);
        const hoteis = getResponseData(response);

        return [...hoteis].sort((a, b) => String(a.fantasia).localeCompare(String(b.fantasia)));
    };

    /* Carrega as subclassificações da classificação selecionada, com o vínculo já marcado */
    loadSubClassificacoes = async (idatendimento, idclassifatendimento) => {
        if (!idclassifatendimento) {
            return { subclassificacoes: [], selecionadas: new Set() };
        }

        const response = await api.get(
            `/atendimentosac/${idatendimento || 0}/subclassificacao/${idclassifatendimento}`
        );

        const subclassificacoes = getResponseData(response);

        const selecionadas = new Set(
            subclassificacoes.filter(
                item => item.idatendimento
            ).map(item => Number(item.idsubclassifatendsac))
        );

        return { subclassificacoes, selecionadas };
    };

    /* Carrega os detalhes do atendimento */
    loadDetalhes = async (idatendimento) => {
        if (!idatendimento) return [];

        const response = await api.get(`/atendimentosac/${idatendimento}/detalhe`);

        return getResponseData(response);
    };

    /* Carrega o atendimento SAC */
    loadAtendimento = async (id, isView) => {
        const { history } = this.props;

        const response = await api.get(`/atendimentosac/${id}`);
        const registro = getRecordFromResponse(response);

        if (!registro) {
            this.handleOpenAlert('Atendimento SAC não encontrado!');

            history.push(this.getBasePath());

            return;
        }

        const [
            classificacoes,
            hoteis,
            osSelecionada,
            {
                subclassificacoes,
                selecionadas
            },
            detalhes
        ] = await Promise.all([
            this.loadClassificacoes(registro.idclassifatendimento),
            this.loadHoteis(registro.codhotel),
            this.loadOsSelecionada(registro.codos),
            this.loadSubClassificacoes(id, registro.idclassifatendimento),
            this.loadDetalhes(id)
        ]);

        this.safeSetState({
            atendimento: {
                ...registro,
                datain: registro.datain || '',
                datafim: registro.datafim || '',
                situacao: registro.situacao || ATEND_SAC_ABERTO
            },
            classificacoes,
            hoteis,
            osSelecionada,
            subclassificacoes,
            subclassificacoesSelecionadas: selecionadas,
            detalhes,
            isNewRecord: false,
            isView,
            isLoading: false
        });
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { name, value } = event.target;

        this.setState(prevState => ({
            atendimento: {
                ...prevState.atendimento,
                [name]: [
                    'telefone1',
                    'telefone2',
                    'nroreservacli',
                    'nomespax'
                ].includes(name) ? String(value).toUpperCase() : value
            }
        }));
    };

    /* Muda a classificação */
    onChangeClassificacao = async (event) => {
        const idclassifatendimento = event.target.value;
        const { atendimento } = this.state;

        this.setState(prevState => ({
            atendimento: {
                ...prevState.atendimento,
                idclassifatendimento
            }
        }));

        const { subclassificacoes, selecionadas } = await this.loadSubClassificacoes(
            atendimento.idatendimento,
            idclassifatendimento
        );

        this.safeSetState({
            subclassificacoes,
            subclassificacoesSelecionadas: selecionadas
        });
    };

    /* Marca ou desmarca uma subclassificação */
    onChangeSubClassificacao = (idsubclassifatendsac) => {
        this.setState(prevState => {
            const subclassificacoesSelecionadas = new Set(prevState.subclassificacoesSelecionadas);

            if (subclassificacoesSelecionadas.has(idsubclassifatendsac)) {
                subclassificacoesSelecionadas.delete(idsubclassifatendsac);
            } else {
                subclassificacoesSelecionadas.add(idsubclassifatendsac);
            }

            return { subclassificacoesSelecionadas };
        });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.safeSetState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Retorna o payload de atendimento SAC */
    getPayloadAtendimento = () => {
        const { atendimento, subclassificacoesSelecionadas } = this.state;

        return {
            idclassifatendimento: atendimento.idclassifatendimento || '',
            codos: atendimento.codos || '',
            nroreservacli: atendimento.nroreservacli || '',
            codhotel: atendimento.codhotel || '',
            datain: atendimento.datain || '',
            datafim: atendimento.datafim || '',
            telefone1: atendimento.telefone1 || '',
            telefone2: atendimento.telefone2 || '',
            nomespax: atendimento.nomespax || '',
            subclassificacoes: Array.from(subclassificacoesSelecionadas)
        };
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { atendimento, isNewRecord } = this.state;
        const { history, loadAtendimento } = this.props;

        const errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        try {
            const payload = this.getPayloadAtendimento();

            if (isNewRecord) {
                await api.post('/atendimentosac', payload);
            } else {
                await api.put(`/atendimentosac/${atendimento.idatendimento}`, payload);
            }

            if (loadAtendimento) loadAtendimento();

            history.push(this.getBasePath());
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                getApiErrorMessage(error, 'Erro ao salvar!')
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = async () => {
        const { atendimento, criadoNaSessao } = this.state;

        if (criadoNaSessao) {
            try {
                await api.delete(`/atendimentosac/${atendimento.idatendimento}`);
            } catch (error) {
                this.handleOpenAlert(
                    getApiErrorMessage(error, 'Erro ao descartar o atendimento!')
                );

                return;
            }
        }

        this.props.history.push(this.getBasePath());
    };

    /* Caminho base da tela */
    getBasePath = () => {
        const path = this.props.match?.path || '/crm/atendimentosac/:id';

        return path.replace('/:id', '');
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { atendimento, schema } = this.state;

        return validateSchemaFields(atendimento, schema, ['idclassifatendimento']);
    };

    /* Verifica se a classificação selecionada é válida */
    isClassificacaoValida = () => {
        const { idclassifatendimento } = this.state.atendimento;

        return !!idclassifatendimento && String(idclassifatendimento) !== '0';
    };

    /* Grava o atendimento novo sem sair da tela, pra poder lançar detalhes nele */
    gravaAtendimentoParaDetalhe = async () => {
        try {
            const payload = this.getPayloadAtendimento();
            const response = await api.post('/atendimentosac', payload);
            const idatendimento = response?.data?.idatendimento;

            if (!idatendimento) {
                this.handleOpenAlert('Não foi possível gravar o atendimento!');

                return null;
            }

            return idatendimento;
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                getApiErrorMessage(error, 'Erro ao salvar!')
            );

            return null;
        }
    };

    /* Abre a janela pra adicionar um novo detalhe */
    onClickAdicionarDetalhe = async () => {
        const { atendimento, isNewRecord } = this.state;

        if (isNewRecord) {
            const idatendimento = await this.gravaAtendimentoParaDetalhe();

            if (!idatendimento) {
                return;
            }

            this.safeSetState({
                atendimento: {
                    ...atendimento,
                    idatendimento
                },
                isNewRecord: false,
                criadoNaSessao: true,
                openDetalhe: true,
                detalheEditando: null,
                descritivoDetalhe: ''
            });

            return;
        }

        this.setState({
            openDetalhe: true,
            detalheEditando: null,
            descritivoDetalhe: ''
        });
    };

    /* Abre a janela pra alterar um detalhe existente */
    onClickAlterarDetalhe = (detalhe) => {
        this.setState({
            openDetalhe: true,
            detalheEditando: detalhe,
            descritivoDetalhe: detalhe.descritivo || ''
        });
    };

    /* Fecha a janela de detalhe */
    onCloseDetalhe = () => {
        this.setState({
            openDetalhe: false,
            detalheEditando: null,
            descritivoDetalhe: ''
        });
    };

    /* Altera o texto do detalhe */
    onChangeDescritivoDetalhe = (event) => {
        this.setState({ descritivoDetalhe: event.target.value });
    };

    /* Confirma a inclusão ou alteração do detalhe */
    onConfirmaDetalhe = async () => {
        const { atendimento, descritivoDetalhe, detalheEditando } = this.state;

        if (!descritivoDetalhe || !descritivoDetalhe.trim()) {
            this.handleOpenAlert('Obrigatório informar descritivo do registro!');

            return;
        }

        try {
            if (detalheEditando) {
                await api.put(`/detatendimentosac/${detalheEditando.iddetatendsac}`, {
                    descritivo: descritivoDetalhe
                });
            } else {
                await api.post(`/atendimentosac/${atendimento.idatendimento}/detalhe`, {
                    descritivo: descritivoDetalhe
                });
            }

            const detalhes = await this.loadDetalhes(atendimento.idatendimento);

            this.safeSetState({ detalhes });
            this.onCloseDetalhe();
        } catch (error) {
            this.handleOpenAlert(
                getApiErrorMessage(error, 'Erro ao gravar o detalhe!')
            );
        }
    };

    /* Abre a confirmação de exclusão de um detalhe */
    onClickExcluirDetalhe = (detalhe) => {
        this.setState({
            openExcluirDetalhe: true,
            detalheParaExcluir: detalhe
        });
    };

    /* Fecha a confirmação de exclusão sem excluir */
    onCloseExcluirDetalhe = () => {
        this.setState({
            openExcluirDetalhe: false,
            detalheParaExcluir: null
        });
    };

    /* Confirma e exclui o detalhe */
    onConfirmExcluirDetalhe = async () => {
        const { atendimento, detalheParaExcluir } = this.state;

        try {
            await api.delete(`/detatendimentosac/${detalheParaExcluir.iddetatendsac}`);

            const detalhes = await this.loadDetalhes(atendimento.idatendimento);

            this.safeSetState({ detalhes });
            this.onCloseExcluirDetalhe();
        } catch (error) {
            this.onCloseExcluirDetalhe();

            this.handleOpenAlert(
                getApiErrorMessage(error, 'Erro ao excluir o detalhe!')
            );
        }
    };

    render() {
        const {
            atendimento,
            classificacoes,
            descritivoDetalhe,
            detalheEditando,
            detalheParaExcluir,
            detalhes,
            errors,
            hoteis,
            isLoading,
            isNewRecord,
            isView,
            openAlert,
            openDetalhe,
            openExcluirDetalhe,
            osBuscaAberta,
            osBuscaResultados,
            osBuscando,
            osBuscaTermo,
            osSelecionada,
            messageAlert,
            subclassificacoes,
            subclassificacoesSelecionadas
        } = this.state;

        const { actionIcon } = listStyles;

        if (isLoading) {
            return (
                <CardContent>
                    <Typography variant="body1">
                        Carregando atendimento SAC...
                    </Typography>
                </CardContent>
            );
        }

        const isEncerrado = atendimento.situacao === ATEND_SAC_ENCERRADO;
        const formDisabled = isView || isEncerrado;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Atendimento SAC {atendimento.idatendimento}
                        </Typography>

                        <Box
                            style={{
                                padding: '4px 14px',
                                borderRadius: 6,
                                fontWeight: 'bold',
                                fontFamily: 'Calibri, sans-serif',
                                color: theme.palette.common.white,
                                backgroundColor: isEncerrado ? theme.palette.grey[700] : theme.palette.success.main
                            }}
                        >
                            {isEncerrado ? 'Encerrado' : 'Aberto'}
                        </Box>
                    </Box>

                    {isEncerrado && (
                        <Typography
                            variant="caption"
                            color="textSecondary"
                            style={{
                                display: 'block',
                                marginTop: 4
                            }}
                        >
                            Atendimento encerrado - reabra pela listagem pra poder editar.
                        </Typography>
                    )}

                    <br />

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{ gap: 12 }}
                    >
                        <TextField
                            label="Res. cliente"
                            name="nroreservacli"
                            value={atendimento.nroreservacli || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            disabled={formDisabled}
                            style={{
                                flex: 1,
                                minWidth: 200
                            }}
                        />

                        <TextField
                            label="Data inicial"
                            name="datain"
                            onChange={this.onChange}
                            type="date"
                            value={getDateInputValue(atendimento.datain)}
                            variant="outlined"
                            disabled={formDisabled}
                            InputLabelProps={{ shrink: true }}
                            style={{
                                flex: '0 1 180px',
                                minWidth: 180
                            }}
                        />

                        <TextField
                            label="Data final"
                            name="datafim"
                            onChange={this.onChange}
                            type="date"
                            value={getDateInputValue(atendimento.datafim)}
                            variant="outlined"
                            disabled={formDisabled}
                            InputLabelProps={{ shrink: true }}
                            style={{
                                flex: '0 1 180px',
                                minWidth: 180
                            }}
                        />
                    </Box>

                    <br />

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{ gap: 12 }}
                    >
                        <FormControl
                            variant="outlined"
                            disabled={formDisabled}
                            style={{
                                flex: 1,
                                minWidth: 240
                            }}
                        >
                            <ComboPadrao
                                name={'codhotel'}
                                label={'Hotel'}
                                value={atendimento.codhotel}
                                onChange={this.onChange}
                                fieldId={'codcliente'}
                                listItems={hoteis}
                                fieldDescription={'fantasia'}
                            />
                        </FormControl>

                        <TextField
                            label="Telefone 1"
                            name="telefone1"
                            value={atendimento.telefone1 || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            disabled={formDisabled}
                            style={{
                                flex: 1,
                                minWidth: 160
                            }}
                        />

                        <TextField
                            label="Telefone 2"
                            name="telefone2"
                            value={atendimento.telefone2 || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            disabled={formDisabled}
                            style={{
                                flex: 1,
                                minWidth: 160
                            }}
                        />
                    </Box>

                    <br />

                    <Box>
                        <TextField
                            label="Pax"
                            name="nomespax"
                            value={atendimento.nomespax || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            disabled={formDisabled}
                            fullWidth
                        />
                    </Box>

                    <br />

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        alignItems="center"
                        style={{ gap: 12 }}
                    >
                        <FormControl
                            variant="outlined"
                            disabled={formDisabled}
                            style={{
                                flex: 1,
                                minWidth: 240
                            }}
                        >
                            <ComboPadrao
                                name={'idclassifatendimento'}
                                label={'Classificação'}
                                value={atendimento.idclassifatendimento}
                                onChange={this.onChangeClassificacao}
                                fieldId={'idclassifatendimento'}
                                listItems={classificacoes}
                                fieldDescription={'descclassificacao'}
                                helperText={errors.idclassifatendimento || ''}
                                error={!!errors.idclassifatendimento}
                            />
                        </FormControl>
                    </Box>

                    <br />

                    <Box
                        style={{
                            flex: 1,
                            minWidth: 240
                        }}
                    >
                        {!osBuscaAberta ? (
                            <Box
                                display="flex"
                                alignItems="center"
                                style={{ gap: 4 }}
                            >
                                <TextField
                                    label="OS"
                                    value={osSelecionada ? osSelecionada.descos : 'Nenhuma OS selecionada'}
                                    variant="outlined"
                                    disabled
                                    fullWidth
                                />

                                {!formDisabled && (
                                    <Tooltip title={osSelecionada ? 'Trocar OS' : 'Buscar OS'}>
                                        <Search
                                            onClick={this.onClickBuscarOs}
                                            onMouseEnter={this.handleIconMouseEnter}
                                            onMouseLeave={this.handleIconMouseLeave}
                                            style={actionIcon}
                                        />
                                    </Tooltip>
                                )}

                                {!formDisabled && osSelecionada && (
                                    <Tooltip title="Remover OS">
                                        <Close
                                            onClick={this.onClickLimparOs}
                                            onMouseEnter={this.handleDeleteIconMouseEnter}
                                            onMouseLeave={this.handleIconMouseLeave}
                                            style={actionIcon}
                                        />
                                    </Tooltip>
                                )}
                            </Box>
                        ) : (
                            <Box>
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    style={{ gap: 4 }}
                                >
                                    <TextField
                                        autoFocus
                                        label="OS"
                                        placeholder="Digite o número ou o titular e pressione Enter"
                                        variant="outlined"
                                        value={osBuscaTermo}
                                        onChange={this.onChangeOsBuscaTermo}
                                        onKeyDown={this.onKeyDownBuscaOs}
                                        fullWidth
                                    />

                                    <Tooltip title="Procurar">
                                        <Search
                                            onClick={this.onBuscarOs}
                                            onMouseEnter={this.handleIconMouseEnter}
                                            onMouseLeave={this.handleIconMouseLeave}
                                            style={actionIcon}
                                        />
                                    </Tooltip>

                                    <Tooltip title="Cancelar">
                                        <Close
                                            onClick={this.onClickFecharBuscaOs}
                                            onMouseEnter={this.handleDeleteIconMouseEnter}
                                            onMouseLeave={this.handleIconMouseLeave}
                                            style={actionIcon}
                                        />
                                    </Tooltip>
                                </Box>

                                {osBuscando && (
                                    <Typography
                                        variant="caption"
                                        color="textSecondary"
                                        style={{
                                            display: 'block',
                                            marginTop: 6
                                        }}
                                    >
                                        Buscando...
                                    </Typography>
                                )}

                                {!osBuscando && osBuscaResultados.length > 0 && (
                                    <Box
                                        style={{
                                            border: `1px solid ${theme.palette.grey[400]}`,
                                            borderRadius: 8,
                                            marginTop: 6,
                                            maxHeight: 180,
                                            overflowY: 'auto'
                                        }}
                                    >
                                        {osBuscaResultados.map(os => (
                                            <Box
                                                key={os.codos}
                                                onClick={() => this.onSelectOs(os)}
                                                style={{
                                                    padding: '8px 12px',
                                                    cursor: 'pointer',
                                                    borderBottom: `1px solid ${theme.palette.grey[200]}`
                                                }}
                                            >
                                                {os.descos}
                                            </Box>
                                        ))}
                                    </Box>
                                )}
                            </Box>
                        )}
                    </Box>

                    <br />
                    <br />

                    <Box>
                        <Typography
                            color="textSecondary"
                            component="p"
                            variant="body2"
                        >
                            Subclassificação
                        </Typography>

                        <Box
                            style={{
                                border: `1px solid ${theme.palette.grey[400]}`,
                                borderRadius: 8,
                                padding: '8px 12px',
                                marginTop: 8,
                                maxHeight: 160,
                                overflowY: 'auto'
                            }}
                        >
                            {subclassificacoes.length === 0 && (
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                >
                                    {atendimento.idclassifatendimento
                                        ? 'Nenhuma subclassificação cadastrada pra essa classificação'
                                        : 'Selecione a classificação primeiro'
                                    }
                                </Typography>
                            )}

                            {subclassificacoes.map(item => (
                                <FormControlLabel
                                    key={item.idsubclassifatendsac}
                                    label={item.descsubclassificacao}
                                    style={{ display: 'flex' }}
                                    control={
                                        <Checkbox
                                            checked={subclassificacoesSelecionadas.has(Number(item.idsubclassifatendsac))}
                                            onChange={() => this.onChangeSubClassificacao(Number(item.idsubclassifatendsac))}
                                            color="primary"
                                            disabled={formDisabled}
                                        />
                                    }
                                />
                            ))}
                        </Box>
                    </Box>

                    <br />
                    <br />

                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Typography
                            component="h2"
                            variant="h5"
                        >
                            Detalhes do atendimento
                        </Typography>

                        {!isView && (
                            <Tooltip title={this.isClassificacaoValida() ? '' : 'Selecione a classificação primeiro'}>
                                <span>
                                    <Button
                                        variant="outlined"
                                        color="secondary"
                                        onClick={this.onClickAdicionarDetalhe}
                                        disabled={!this.isClassificacaoValida()}
                                        style={{ textTransform: 'none' }}
                                    >
                                        Adicionar
                                    </Button>
                                </span>
                            </Tooltip>
                        )}
                    </Box>

                    <br />

                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">Seq.</TableCell>

                                <TableCell align="center">Registrado por</TableCell>

                                <TableCell align="center">Data/hora</TableCell>

                                <TableCell align="center">Descritivo</TableCell>

                                <TableCell align="center">Ações</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {detalhes.length === 0 && (
                                <TableRow>
                                    <TableCell
                                        align="center"
                                        colSpan={5}
                                    >
                                        Nenhum detalhe registrado
                                    </TableCell>
                                </TableRow>
                            )}

                            {detalhes.map(detalhe => (
                                <TableRow key={detalhe.iddetatendsac}>
                                    <TableCell align="center">{detalhe.seq}</TableCell>

                                    <TableCell align="center">{detalhe.usuario}</TableCell>

                                    <TableCell align="center">{formatTime(detalhe.datahoraregistro)}</TableCell>

                                    <TableCell align="center">{detalhe.descritivo}</TableCell>

                                    <TableCell align="center">
                                        <span style={listStyles.iconGroup}>
                                            <Tooltip title="Editar">
                                                <EditTwoTone
                                                    onClick={() => this.onClickAlterarDetalhe(detalhe)}
                                                    onMouseEnter={this.handleIconMouseEnter}
                                                    onMouseLeave={this.handleIconMouseLeave}
                                                    style={listStyles.actionIcon}
                                                />
                                            </Tooltip>

                                            <Tooltip title="Excluir">
                                                <DeleteForeverOutlined
                                                    onClick={() => this.onClickExcluirDetalhe(detalhe)}
                                                    onMouseEnter={this.handleDeleteIconMouseEnter}
                                                    onMouseLeave={this.handleIconMouseLeave}
                                                    style={listStyles.actionIcon}
                                                />
                                            </Tooltip>
                                        </span>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                    <br />
                    <br />

                    <FormActions
                        onSave={this.onClickSave}
                        onCancel={this.onClickCancel}
                        disableSave={formDisabled}
                    />
                </CardContent>

                <Dialog
                    open={openDetalhe}
                    onClose={this.onCloseDetalhe}
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle>
                        {detalheEditando ? 'Alterar detalhe' : 'Adicionar detalhe'}
                    </DialogTitle>

                    <DialogContent>
                        <TextField
                            autoFocus
                            label="Descritivo"
                            multiline
                            minRows={4}
                            variant="outlined"
                            value={descritivoDetalhe}
                            onChange={this.onChangeDescritivoDetalhe}
                            fullWidth
                        />
                    </DialogContent>

                    <DialogActions>
                        <Button
                            color="secondary"
                            onClick={this.onCloseDetalhe}
                        >
                            Cancelar
                        </Button>

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.onConfirmaDetalhe}
                        >
                            Salvar
                        </Button>
                    </DialogActions>
                </Dialog>

                <DeleteConfirmationModal
                    open={openExcluirDetalhe}
                    itemId={detalheParaExcluir?.iddetatendsac}
                    message="Confirma a exclusão do registro selecionado?"
                    handleClose={this.onCloseExcluirDetalhe}
                    handleDelete={this.onConfirmExcluirDetalhe}
                />

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

AtendimentoSacForm.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    location: PropTypes.object,
    loadAtendimento: PropTypes.func
};

export default AtendimentoSacForm;